import { render, staticRenderFns } from "./AdvertsArchive.vue?vue&type=template&id=11aeafd4&"
import script from "./AdvertsArchive.vue?vue&type=script&lang=js&"
export * from "./AdvertsArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports